import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserByIdRequest } from '../store/user/actions/user-actions';

const UserDetails = ({ userId }) => {
    const dispatch = useDispatch();
    const selectedUser = useSelector(state => state.user?.selectedUser);
    const loading = useSelector(state => state.user?.loading || false);
    const error = useSelector(state => state.user?.error);

    useEffect(() => {
        if (userId) {
            dispatch(fetchUserByIdRequest(userId));
        }
    }, [userId, dispatch]);

    if (!userId) {
        return <div className="text-gray-500 italic">No user selected</div>;
    }

    if (loading) {
        return <div className="text-gray-600">Loading user details...</div>;
    }

    if (error) {
        return <div className="text-red-500">Error: {error}</div>;
    }

    if (!selectedUser) {
        return <div className="text-gray-500">User not found</div>;
    }

    return (
        <div className="bg-white p-6 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">User Details</h3>
            <div className="space-y-2">
                {selectedUser.id && (
                    <p className="text-gray-700">
                        <strong>ID:</strong> {selectedUser.id}
                    </p>
                )}
                {selectedUser.username && (
                    <p className="text-gray-700">
                        <strong>Username:</strong> {selectedUser.username}
                    </p>
                )}
                {selectedUser.email && (
                    <p className="text-gray-700">
                        <strong>Email:</strong> {selectedUser.email}
                    </p>
                )}
                {selectedUser.firstName && (
                    <p className="text-gray-700">
                        <strong>First Name:</strong> {selectedUser.firstName}
                    </p>
                )}
                {selectedUser.lastName && (
                    <p className="text-gray-700">
                        <strong>Last Name:</strong> {selectedUser.lastName}
                    </p>
                )}
                {selectedUser.createdAt && (
                    <p className="text-gray-700">
                        <strong>Created At:</strong> {selectedUser.createdAt}
                    </p>
                )}
                {selectedUser.updatedAt && (
                    <p className="text-gray-700">
                        <strong>Updated At:</strong> {selectedUser.updatedAt}
                    </p>
                )}
            </div>
        </div>
    );
};

export default UserDetails;
